import { roundPrice } from "~/utils/payment";
import type AccountPaymentInfo from "../../../account/AccountPaymentInfo";
import type AccountProgramInfo from "../../../account/AccountProgramInfo";
import type DiscountInfo from "../../DiscountInfo";
import type DiscountInfoType from "../../DiscountInfoType";
import type ProgramDiscountStrategy from "./ProgramDiscountStrategy";
import _ from "lodash";

export default class CustomerProgramDiscountStrategy implements ProgramDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "customer";
  }

  getDiscountInfo(accountProgramInfo: AccountProgramInfo, accountPaymentInfo: AccountPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "customer",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Customer Discount only applies if:
      - There is a customer discount.
     */
    const customerDiscount = accountPaymentInfo.franchiseDiscounts.find((franchiseDiscount) => franchiseDiscount.name === "CustomerDiscount");

    if (customerDiscount) {
      const customerDiscountValue = customerDiscount?.value ?? 0;
      const customerDiscountDescription = customerDiscount?.description ?? "Customer Discount";

      discountInfo.description = `${customerDiscountDescription} (${customerDiscountValue * 100}%) - ${accountProgramInfo.title}`;
      discountInfo.value = customerDiscountValue;
      discountInfo.amount = roundPrice((accountProgramInfo.subtotal ?? 0) * (discountInfo.value), "nearest", 2);
    }

    return discountInfo;
  }
}
